import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiftBox: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gift-box, present"><path d="M2 4.75C2 4.33579 2.33579 4 2.75 4H11.25V9H2.75C2.33579 9 2 8.66421 2 8.25V4.75Z" fill="currentColor"/><path d="M3 10.5H11.25V20H3.75C3.33579 20 3 19.6642 3 19.25V10.5Z" fill="currentColor"/><path d="M12.75 4H21.25C21.6642 4 22 4.33579 22 4.75V8.25C22 8.66421 21.6642 9 21.25 9H12.75V4Z" fill="currentColor"/><path d="M12.75 10.5H21V19.25C21 19.6642 20.6642 20 20.25 20H12.75V10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconGiftBox;
